import cn from "@/utils/cn"
import { ReactNode } from "react"

type InputErrorMessage = {
  message?: ReactNode
  className?: string
}

const InputErrorMessage = (props: InputErrorMessage) => {
  const { message, className } = props
  return (
    <div className={cn("text-sm italic text-red-600", className)}>
      {message ? message : ""}
    </div>
  )
}

export default InputErrorMessage
